import Main from '../../views/main'
export default [
  /* -------------- 开发者 ------------- */
  {
    path: '/developer',
    name: 'Developer',
    component: Main,
    meta: {
      hideInBread: true,
      disabled: true
    },
    children: [
      {
        path: 'config',
        name: 'DeveloperConfig',
        component: () => import(/* webpackChunkName: "test" */ '@/views/Developer/developerConfig'),
        meta: {
          label: '开发者选项',
          icon: '$vuetify.icons.code'
        }
      },
    ]
  },
]
